export default __webpack_public_path__ + "static/media/manifest_tracking.fa3b4b7c.svg";